import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { SapHanaLinkedService } from '../linkedservice/saphana.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapHana.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SapHana_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SapHana_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapHanaLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapHanaDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
